export default {
  meta: {
    title: $localize`:@@meta.promo.title:Получи сочные скины`,
    description: $localize`:@@meta.promo.desc:Легко и быстро поднимай скины с лучшим блоггером`
  }
};